import React, { useState, useRef } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./anexos.css";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

const EvidenciaJuridica = () => {
  const cookie = new Cookies();
  const [files, setFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);
  const { id } = useParams();
  const navigate = useNavigate();

  const API_URL = `https://contratosback.azurewebsites.net/api/v1/AdjuntaArchivos/${id}/${cookie.get(
    "id"
  )}`;

  const handleFiles = (selectedFiles) => {
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };

  const handleFileChange = (e) => {
    handleFiles(Array.from(e.target.files));
    e.target.value = null;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    handleFiles(droppedFiles);
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleSaveFiles = async () => {
    if (!files.length) {
      return Swal.fire({
        icon: "warning",
        title: "Sin archivos",
        text: "Por favor, selecciona al menos un archivo.",
      });
    }

    setIsLoading(true);
    const formData = new FormData();
    files.forEach((file) => formData.append("archivos", file));

    try {
      await axios.post(API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: "Archivos enviados con éxito.",
        timer: 2000,
        showConfirmButton: false,
      });

      setFiles([]);
    } catch (error) {
      console.error("Error al enviar los archivos:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un error al enviar los archivos.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleFinish = () => navigate("/SolicitudesPropias/" + cookie.get("correo"));

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card className="shadow-lg" style={{ width: "40rem" }}>
        <CardHeader className="bg-secondary text-white text-center">
          <h4>Documentos Anexos</h4>
        </CardHeader>
        <CardBody>
          <FormGroup>
            <div
              className={`drag-drop-area ${isDragging ? "dragging" : ""}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
              style={{
                border: "2px dashed #ccc",
                padding: "2rem",
                textAlign: "center",
                cursor: "pointer",
                backgroundColor: isDragging ? "#f0f8ff" : "#fafafa",
              }}
            >
              <p>Arrastre archivos aquí o haga clic para seleccionarlos</p>
              <input
                type="file"
                multiple
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </div>
          </FormGroup>

          {!!files.length && (
            <>
              <h5>Documentos seleccionados:</h5>
              <ListGroup>
                {files.map((file, index) => (
                  <ListGroupItem
                    key={index}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      {file.name} ({(file.size / 1024).toFixed(2)} KB)
                    </span>
                    <Button color="danger" size="sm" onClick={() => handleRemoveFile(index)}>
                      Eliminar
                    </Button>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </>
          )}

          <Button
            color="primary"
            className="mt-3"
            onClick={handleSaveFiles}
            disabled={isLoading || !files.length}
          >
            {isLoading ? "Enviando..." : "Guardar Documentos"}
          </Button>

          <hr />

          <Button color="danger" onClick={handleFinish}>
            Finalizar
          </Button>
        </CardBody>
      </Card>
    </Container>
  );
};

export default EvidenciaJuridica;
